import type { SectionId } from './nav-items';
import { navItemFor } from './nav-items';

// Design deep links (`?sec=&tab=`, D:6533-6551 + `syncUrl` D:7180) resolved onto
// the console's path routes (PRD §7.3.4). A link such as `/?sec=approvals&tab=claims`
// — from an email, a bookmark of the design prototype, or the parity harness —
// lands on `/approvals?tab=claims`. Design section ids that were renamed map to
// their route; deferred sections (waitlist, accounts, adreview, ads, adspolicy,
// help) resolve to nothing and the link is ignored (DR-43).

const DESIGN_SEC: Record<string, SectionId> = {
  overview: 'overview',
  approvals: 'approvals',
  listings: 'services',
  services: 'services',
  bookings: 'bookings',
  offers: 'offers',
  disputes: 'disputes',
  reviews: 'reviews',
  merchants: 'merchants',
  businesses: 'businesses',
  customers: 'customers',
  pricing: 'pricing',
  payments: 'payments',
  reports: 'reports',
  templates: 'templates',
  categories: 'categories',
  locations: 'locations',
  cms: 'cms',
  maps: 'maps',
  notifs: 'notifications',
  notifications: 'notifications',
  roles: 'roles',
};

const TAB_RE = /^[a-z0-9_-]{1,32}$/;

/** The path a `?sec=&tab=` query resolves to, or null when it carries no section. */
export function deepLinkTarget(search: string): string | null {
  const params = new URLSearchParams(search);
  const sec = params.get('sec');
  if (!sec) return null;
  const section = DESIGN_SEC[sec];
  if (!section) return null;
  const tab = params.get('tab');
  const path = navItemFor(section).to;
  return tab && TAB_RE.test(tab) ? `${path}?tab=${tab}` : path;
}
